webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d35664d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__(102);
function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var normalizeComponent = __webpack_require__(5)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d35664d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d35664d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"spinner-wrapper"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect1"}),_vm._v(" "),_c('div',{staticClass:"rect2"}),_vm._v(" "),_c('div',{staticClass:"rect3"}),_vm._v(" "),_c('div',{staticClass:"rect4"}),_vm._v(" "),_c('div',{staticClass:"rect5"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"header"},[_c('button',{staticClass:"hamburger hamburger--collapse",class:{ active: _vm.menu },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.menu = !_vm.menu}}},[_vm._m(0)]),_vm._v(" "),_c('span',{staticClass:"month-year"},[_vm._v("\n      Rogel Cancer Center Events\n    ")])]),_vm._v(" "),_c('Menu',{attrs:{"menu":_vm.menu,"menus":_vm.calendars,"loading":_vm.loading},on:{"toggle-item":_vm.toggleCalendarItem}}),_vm._v(" "),_c('div',{staticClass:"events-template"},[_c('div',{staticClass:"month-selector"},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.loading)?_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentMonth != _vm.minMonth),expression:"currentMonth != minMonth"}],staticClass:"icon-left-open-big month-selector-arrow prev",attrs:{"href":"#"},on:{"click":function($event){_vm.changeMonth('prev')}}}):_vm._e()]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.month))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(!_vm.loading)?_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentMonth != _vm.maxMonth),expression:"currentMonth != maxMonth"}],staticClass:"icon-right-open-big month-selector-arrow next",attrs:{"href":"#"},on:{"click":function($event){_vm.changeMonth('next')}}}):_vm._e()])],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"day-list-wrapper"},[(_vm.noResults)?_c('div',{staticClass:"no-results"},[_vm._v("No events found. Please try another month or\n          select different calendars from the menu.\n      ")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.events.length > 0),expression:"events.length > 0"}],staticClass:"day-list"},_vm._l((_vm.sortedDays),function(day){return _c('li',{key:day.day},[_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-integer"},[_vm._v(_vm._s(day.day))]),_vm._v(" "+_vm._s(day.dayWeek)+"\n            ")]),_vm._v(" "),_c('ul',{staticClass:"event-list"},[_c('transition-group',{attrs:{"name":"fade"}},_vm._l((_vm.sortedEvents),function(event){return (_vm.eventActive(event, day))?_c('li',{key:event.id,staticClass:"event"},[_c('Event',{attrs:{"event":event}})],1):_vm._e()}))],1)])}))])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"},[_vm._v("☰")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Events',{attrs:{"api":_vm.api,"loading":_vm.loading},on:{"enable-loading":_vm.enableLoading,"disable-loading":_vm.disableLoading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Events_vue__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Events: __WEBPACK_IMPORTED_MODULE_0__components_Events_vue__["a" /* default */]
  },

  data: function data() {
    return {
      api: "https://master-7rqtwti-blb5cbodtjgb6.us.platform.sh",
      loading: true
    };
  },


  methods: {
    enableLoading: function enableLoading() {
      this.loading = true;
    },
    disableLoading: function disableLoading() {
      this.loading = false;
    }
  }
});

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Event_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(100);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      calendars: {},
      days: [],
      month: "",
      events: [],
      minMonth: "",
      maxMonth: "",
      noResults: false,
      currentMonth: "",
      currentYearOnly: "",
      currentMonthOnly: "",
      menu: false,
      eventsLoaded: false
    };
  },


  components: {
    Event: __WEBPACK_IMPORTED_MODULE_3__components_Event_vue__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu_vue__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */]],

  props: ["api", "loading"],

  computed: {
    sortedDays: function sortedDays() {
      return this.days.sort(function (a, b) {
        return a.day - b.day;
      });
    },
    sortedEvents: function sortedEvents() {
      return this.events.sort(function (a, b) {
        if (a.start24 < b.start24) {
          return -1;
        }

        if (a.start24 > b.start24) {
          return 1;
        }

        return 0;
      });
    },
    checkForResults: function checkForResults() {
      this.noResults = this.days > 0 ? false : true;
    }
  },

  mounted: function mounted() {
    var _this = this;

    // Get the current month and year.
    var month = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().toFormat("LL");
    var year = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().toFormat("y");
    var nextYear = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().plus({ year: 1 }).toFormat("y");

    // Fetch calendars.
    var calendarPromise = this.getCalendars();

    calendarPromise.then(function (fetchedCalendars) {
      return _this.parseCalendarData(fetchedCalendars);
    })

    // Store calendar data in vue object.
    .then(function (parsedCalendarData) {
      _this.calendars = parsedCalendarData;
      return _this.calendars;
    })

    // Check status of calendars.
    .then(function (calendars) {
      _this.checkCalendarsStatus(calendars);
    })

    // Grab events after calendars have been fetched.
    .then(function () {
      var url = _this.api + "/api/node/event?filter[event_month][value]=" + month + "&filter[event_year][value]=" + year;

      // Set current month and year.
      _this.currentMonth = year + month;
      _this.currentMonthOnly = month;
      _this.currentYearOnly = year;

      // Set current month and year for display.
      _this.month = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().toFormat("LLLL y");

      // Set the min and max months available.
      _this.minMonth = year + month;
      _this.maxMonth = nextYear + month;

      // Grab events.
      var eventsPromise = _this.getEvents(url);

      // Promise that you won't move on until you have all the events.
      eventsPromise.then(function (events) {
        _this.parseEventData(events);
      })

      // Add days.
      .then(function () {
        _this.addDays(_this.events);
      })

      // Check for no results.
      .then(function () {
        _this.noResults = _this.days.length > 0 ? false : true;
      })

      // Disable loading.
      .then(function () {
        _this.$emit("disable-loading");
      });
    });
  },


  methods: {
    eventActive: function eventActive(event, day) {
      if (event.day == day.day && this.calendars[event.calendar].checked && event.month + " " + event.year === this.month) {

        return true;
      }
    },
    addDays: function addDays(events) {
      var _this2 = this;

      var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // Create days that have events in the month.
      events.forEach(function (event) {
        if (_this2.calendars[event.calendar].checked) {

          // Check to see if the object already exists in the array.
          if (_this2.days.find(function (obj) {
            return obj.day === event.day;
          }) === undefined) {

            _this2.days.push({
              day: event.day,
              dayWeek: event.dayWeek
            });
          }
        }
      });
    },
    toggleCalendarItem: function toggleCalendarItem() {
      var _this3 = this;

      // Disable menu
      this.menu = false;

      // Enable loading.
      this.$emit("enable-loading");

      // Reset events array.
      this.events = [];

      // Reset the days array.
      this.days = [];

      // Fetch new events.
      var url = this.api + "/api/node/event?filter[event_month][value]=" + this.currentMonthOnly + "&filter[event_year][value]=" + this.currentYearOnly;

      var eventsPromise = this.getEvents(url);

      eventsPromise.then(function (events) {
        _this3.parseEventData(events);
      })

      // Add days.
      .then(function () {
        _this3.addDays(_this3.events);
      })

      // Check for no results.
      .then(function () {
        _this3.noResults = _this3.days.length > 0 ? false : true;
      })

      // Disable loading.
      .then(function () {
        _this3.$emit("disable-loading");
      });
    },


    // Changes the month and fetches new data from the API.
    // Provide either next or prev to change the month accordingly.
    changeMonth: function changeMonth() {
      var _this4 = this;

      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : next;

      var newDate = {};

      // Disable menu.
      this.menu = false;

      // Set loading true to show animation.
      this.$emit("enable-loading");

      if (direction === "next") {
        newDate = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(this.currentMonth).plus({ month: 1 });
      }

      if (direction === "prev") {
        newDate = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(this.currentMonth).minus({ month: 1 });
      }

      var newMonth = newDate.toFormat("LL");
      var newYear = newDate.toFormat("y");

      // Set new values.
      this.month = newDate.toFormat("LLLL y");
      this.currentMonth = newDate.toFormat("yLL");
      this.currentMonthOnly = newDate.toFormat("LL");
      this.currentYearOnly = newDate.toFormat("y");

      // Remove existing events.
      this.events = [];
      this.days = [];

      // Grab the events.
      var url = this.api + "/api/node/event?filter[event_month][value]=" + newMonth + "&filter[event_year][value]=" + newYear;

      var eventsPromise = this.getEvents(url);

      eventsPromise.then(function (events) {
        setTimeout(function () {
          _this4.parseEventData(events);
        }, 50);
      })

      // Add days.
      .then(function () {
        setTimeout(function () {
          _this4.addDays(_this4.events);
        }, 50);
      })

      // Check for results.
      .then(function () {
        setTimeout(function () {
          _this4.noResults = _this4.days.length > 0 ? false : true;
        }, 50);
      })

      // Disable loading.
      .then(function () {
        setTimeout(function () {
          _this4.$emit("disable-loading");
        }, 50);
      });
    }
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getCalendars: function getCalendars() {
      return fetch(this.api + "/api/node/calendar")

      // Get response from server.
      .then(function (response) {
        return response.json();
      })

      // Return the data object.
      .then(function (response) {
        return response.data;
      });
    },
    parseCalendarData: function parseCalendarData(data) {
      var calendars = {};

      // Set calendar data.
      data.forEach(function (calendar) {
        // Ensure cancer center calendar comes in checked.
        var checked = calendar.attributes.calendar_id == "med-cancer-center@umich.edu" ? true : false;

        // Add to calendars object.
        calendars[calendar.attributes.calendar_id] = {
          name: calendar.attributes.title,
          id: calendar.attributes.calendar_id,
          checked: checked
        };
      });

      return calendars;
    },


    /**
     * Returns all events from the API, I promise...
     *
     * @param {string} url
     * @param {array} events
     */
    getEvents: function getEvents(url) {
      var _this = this;

      var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return fetch(url).then(function (response) {
          response.json().then(function (data) {
            events = events.concat(data.data);

            if (data.links.next) {
              _this.getEvents(data.links.next.href, events).then(resolve).catch(reject);
            } else {
              resolve(events);
            }
          }).catch(reject);
        }).catch(reject);
      });
    },
    checkCalendarsStatus: function checkCalendarsStatus(calendars) {
      var localCalendars = JSON.parse(localStorage.getItem("umcancer-event-app-calendars"));

      if (localCalendars) {
        // Loop through calendars to see if any should be unchecked.
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(localCalendars).forEach(function (key) {
          calendars[key].checked = localCalendars[key].checked;
        });
      }

      // Save calendars to localStorage.
      localStorage.setItem("umcancer-event-app-calendars", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(calendars));

      return calendars;
    },
    parseEventData: function parseEventData(events) {
      var _this2 = this;

      // Fetch if the calendar is checked.
      events.forEach(function (event) {
        var calendar = event.attributes.event_calendar;
        var day = void 0,
            dayWeek = void 0,
            year = void 0,
            end = void 0,
            month = void 0,
            start = void 0,
            monthInt = void 0,
            start24 = void 0,
            description = void 0;

        // Calculate some date values.
        if (event.attributes.event_start_date) {
          day = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(event.attributes.event_start_date).toFormat("dd");
          dayWeek = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(event.attributes.event_start_date).toFormat("cccc");
          year = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(event.attributes.event_start_date).toFormat("yyyy");
          month = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(event.attributes.event_start_date).toLocaleString({ month: "long" });
          start = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(event.attributes.event_start_date).toLocaleString(__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].TIME_SIMPLE);
          end = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(event.attributes.event_end_date).toLocaleString(__WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].TIME_SIMPLE);
          start24 = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(event.attributes.event_start_date).toFormat("T");
        } else {
          day = event.attributes.event_day;
          year = event.attributes.event_year;

          // Form a date iso to pass to luxon.
          var _monthInt = event.attributes.event_month;
          var dateISO = year + _monthInt + day;

          // Figure out day week and month from created ISO.
          dayWeek = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(dateISO).toFormat("cccc");
          month = __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(dateISO).toLocaleString({ month: "long" });
        }
        if (event.attributes.event_description) {
          description = event.attributes.event_description.value;
        }

        // Add events to data object.
        _this2.events.push({
          expanded: false,
          active: true,
          id: event.attributes.drupal_internal__nid,
          title: event.attributes.title,
          location: event.attributes.event_location,
          allDay: event.attributes.event_all_day,
          calendar: event.attributes.event_calendar,
          ics: event.attributes.event_ics,
          description: description,
          startDate: event.attributes.event_start_date,
          endDate: event.attributes.event_end_date,
          day: day,
          dayWeek: dayWeek,
          year: year,
          end: end,
          month: month,
          start: start,
          start24: start24
        });
      });
    }
  }

});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_js__ = __webpack_require__(28);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["menu", "menus", "loading"],

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */]],

  methods: {
    toggleChecked: function toggleChecked(menuItem) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.menus).forEach(function (key) {
        if (_this.menus[key].id == menuItem) {
          var _menuItem = _this.menus[key];
          var newStatus = !_menuItem.checked;

          // Set new status.
          _this.menus[key].checked = newStatus;
        }
      });

      // Add menus to localStorage as calendars.
      localStorage.setItem("umcancer-event-app-calendars", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.menus));

      // Notify parent component of a click.
      this.$emit("toggle-item");
    }
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["event"],

  computed: {
    googleLink: function googleLink() {
      if (this.event.location) {
        return "https://www.google.com/maps/search/?api=1&query=" + this.event.location.replace(/ /g, '+');
      }
    },
    calendarLink: function calendarLink() {
      return this.event.ics;
    }
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_promise_polyfill__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_fontello_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_fontello_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_css_fontello_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// Import fontello


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39eb0fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(104);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39eb0fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_209e9918_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__(103);
function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-209e9918"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_209e9918_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0744cfde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(96);
function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0744cfde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0744cfde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings",class:{ active: _vm.menu }},_vm._l((_vm.menus),function(menu_item){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],key:menu_item.id},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":menu_item.checked},on:{"click":function($event){_vm.toggleChecked(menu_item.id)}}}),_vm._v("\n\n      "+_vm._s(menu_item.name)+"\n    ")])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d29458b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(99);
function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d29458b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d29458b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"event-inner",class:{ active: _vm.event.expanded },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.event.expanded = !_vm.event.expanded}}},[_c('div',{staticClass:"event-time"},[_c('div',{staticClass:"event-start"},[_vm._v(_vm._s(_vm.event.start))]),_vm._v(" "),_c('div',{staticClass:"event-end"},[_vm._v(_vm._s(_vm.event.end))])]),_vm._v(" "),_c('div',{staticClass:"event-title-location"},[_c('div',{staticClass:"event-title"},[_vm._v(_vm._s(_vm.event.title))]),_vm._v(" "),_c('div',{staticClass:"event-location"},[_vm._v(_vm._s(_vm.event.location))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"event-expanded"},[_c('div',{staticClass:"event-expanded-wrapper"},[_c('div',{staticClass:"event-expanded-date-time event-expanded-section"},[_c('div',{staticClass:"icon-clock expanded-icon"}),_vm._v(" "),_c('div',[_c('div',[_vm._v(_vm._s(_vm.event.dayWeek)+", "+_vm._s(_vm.event.month)+" "+_vm._s(_vm.event.day))]),_vm._v(" "),(_vm.event.start)?_c('div',[_vm._v(_vm._s(_vm.event.start)+" - "+_vm._s(_vm.event.end))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"event-expanded-location event-expanded-section"},[_c('div',{staticClass:"icon-location expanded-icon"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.googleLink,"target":"_blank","rel":"noopener"}},[_vm._v("\n\n          "+_vm._s(_vm.event.location)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"event-expanded-description event-expanded-section"},[_c('div',{staticClass:"icon-article-1 expanded-icon"}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.event.description)}})]),_vm._v(" "),_c('a',{staticClass:"add-to-calendar",attrs:{"href":_vm.calendarLink}},[_vm._v("\n        Add to my calendar\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-expand"},[_c('div',{staticClass:"icon-plus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[48]);


// WEBPACK FOOTER //
// static/js/app.76031132ae55ef24599a.js